(function() {
  'use strict';

  // ============================================================
  // CONFIGURATION — update these values
  // ============================================================
  const CONFIG = {
    apiKey: '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',
    popupDelay: 0,                      // Show immediately on page load
    model: 'claude-sonnet-4-5',
  };

  // ============================================================
  // FULL PRODUCT KNOWLEDGE BASE
  // ============================================================
  const PRODUCTS = {
    'bounce-curl-define-brush': {
      name: 'Bounce Curl Define EdgeLift Styling Brush',
      brand: 'Bounce Curl',
      price: 50,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-define-styling-brush',
      shortDesc: 'Widely-spaced bristles gently detangle and form defined curl clumps. The #1 hero for frizz and definition — works on all curl types.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/127.jpg?v=1772173684',
      howToUse: 'Apply styling products to soaking wet hair. Section and brush through with tension, pushing hair up through the ridges to form defined curl clumps. Scrunch after to encourage curl formation.',
      routineStep: 'Use after leave-in & cream/gel (styling step)'
    },
    'bounce-curl-volume-brush': {
      name: 'Bounce Curl Volume EdgeLift Styling Brush',
      brand: 'Bounce Curl',
      price: 52,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-volume-edgelift-brush',
      shortDesc: 'Wider-spaced bristles create thinner curl clumps that stack on each other for serious root lift and volume — the volume-focused sibling of the Define Brush.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/sunshine-curls-bounce-curl-volume-edgelift-brush-upright.jpg?v=1765193915',
      howToUse: 'Apply styling products to soaking wet hair. Work with head tilted forward for root lift. Pull through brush with tension — creates thinner clumps than the Define Brush for maximum volume.',
      routineStep: 'Use after leave-in & cream/gel (styling step)'
    },
    'bounce-curl-slick-flex-brush': {
      name: 'Bounce Curl Slick-Flex Define EdgeLift Brush',
      brand: 'Bounce Curl',
      price: 50,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-slick-flex-define-edgelift-brush',
      shortDesc: 'Lowest-tension one-and-done brush — detangles AND styles in one step. Ultra-soft bristles with the least tension of all four brushes. For fragile, bleached, or severely damaged hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/Bounce-curl-slick-flex-edgelift-define-brush.jpg?v=1773116414',
      howToUse: 'Apply styling products to wet hair first. Using very light pressure, glide brush through each section — allow bristles to guide hair into natural curl formation without forcing tension. Scrunch after to enhance definition.',
      routineStep: 'Use after leave-in & cream/gel. Also safe for pre-style detangling.'
    },
    'bounce-curl-slick-dense-brush': {
      name: 'Bounce Curl Slick-Dense Define EdgeLift Brush',
      brand: 'Bounce Curl',
      price: 50,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-slick-dense-edgelift-brush',
      shortDesc: 'Medium-tension one-and-done brush — detangles AND styles in one step. Gentler than the Define Brush, more tension than the Slick-Flex. Best for colour-treated or lightly damaged hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/slick-dense-teal-main-wht.jpg?v=1773114362',
      howToUse: 'Apply styling products to wet hair. Divide into half-inch sections. Place hair onto brush pad at roots. Glide brush through, allowing hair to fall naturally into the grooves for even curl clumps. Scrunch after to set.',
      routineStep: 'Use after leave-in & cream/gel (styling step)'
    },
    'bounce-curl-hd-bundle': {
      name: 'Bounce Curl High Definition Bundle ($145)',
      brand: 'Bounce Curl',
      price: 145,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-high-definition-bundle',
      shortDesc: 'Define Brush + Avocado Cream + Light Creme Gel — complete styling routine.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/sunshine-curls-bounce-curl-high-definition-bundle-teal_d47db5ce-614b-4a72-af40-c7d1e826e15d.jpg?v=1740481495',
      howToUse: 'Apply cream to wet hair, then gel over the top, then brush through for defined clumps. Scrunch and diffuse or air dry.',
      routineStep: 'Complete styling routine'
    },
    'bounce-curl-weightless-full-set': {
      name: 'Bounce Curl Weightless Collection Full Set',
      brand: 'Bounce Curl',
      price: 240,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-weightless-collection-full-set',
      shortDesc: 'Premium lightweight system for volume-seekers and fine hair. Hydration + definition without weight.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/8.jpg?v=1771905714',
      howToUse: 'Use as a complete volume-first routine in the order provided: shampoo → conditioning mask → leave-in → ceramide jelly or hydra-lite cream.',
      routineStep: 'Complete volume-focused routine'
    },
    'bounce-curl-weightless-duo': {
      name: 'Bounce Curl Weightless Styling Duo',
      brand: 'Bounce Curl',
      price: 96,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-weightless-styling-duo',
      shortDesc: 'Thermal Guard Leave-In + Ceramide Jelly — lightweight hold and definition for fine hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/17_f5907200-ecc5-4fd5-ad98-6312a6f418bc.jpg?v=1771905714',
      howToUse: 'Apply Thermal Guard Leave-In to damp hair first. Then layer Ceramide Jelly over the top. Scrunch and diffuse or air dry. Scrunch out cast when completely dry.',
      routineStep: 'Styling steps 1 & 3 combined (Weightless routine)'
    },
    'bounce-curl-ceramide-jelly': {
      name: 'Bounce Curl Ceramide Jelly',
      brand: 'Bounce Curl',
      price: 49.95,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-ceramide-jelly',
      shortDesc: 'Medium hold, humidity resistant. Ceramides strengthen and smooth the cuticle — great for colour-treated hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/13.png?v=1771906689',
      howToUse: 'Apply to wet hair after leave-in. Smooth and scrunch through sections. Diffuse or air dry. Scrunch out the cast when completely dry.',
      routineStep: 'Styling step 3 — hold layer (Weightless routine)'
    },
    'bounce-curl-avocado-cream': {
      name: 'Bounce Curl Avocado & Rose Oil Curl Cream',
      brand: 'Bounce Curl',
      price: 49,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-avocado-rose-oil-clump-and-define-cream-117ml',
      shortDesc: 'Bestselling curl cream. Medium moisture + medium hold. Softness and definition without stiffness.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/products/bounce-curl-avocado-rose-oil-clump-and-define-cream-117ml-sunshine-curls-626002.jpg?v=1718752452',
      howToUse: 'Apply to soaking wet hair in sections. Rake through and scrunch. Emulsify in palms first. Use alone for moisture OR layer under gel for extra hold.',
      routineStep: 'Styling step 2 — after leave-in, before gel'
    },
    'bounce-curl-moisture-leave-in': {
      name: 'Bounce Curl Moisture Balance Leave-In Conditioner',
      brand: 'Bounce Curl',
      price: 48,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-moisture-balance-leave-in-conditioner',
      shortDesc: 'Ultra-concentrated moisture. Start with a pea-size — a tiny amount goes a very long way.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/sunshine-curls-bounce-curl-moisture-balance-leave-in-conditioner.jpg?v=1718752590',
      howToUse: 'Start with a pea-to-blueberry size amount ONLY. Emulsify in palms until they look white. Apply to soaking wet hair and build up gradually. Hair should feel slightly slippery.',
      routineStep: 'Styling step 1 — leave-in/moisture layer'
    },
    'bounce-curl-weightless-conditioning-mask': {
      name: 'Bounce Curl Weightless Conditioning Mask 296ml',
      brand: 'Bounce Curl',
      price: 49.95,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-weightless-conditioning-mask',
      shortDesc: 'Hydrates fine hair without any heaviness. No flatten-your-curls conditioning.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/10_d3eab1fb-5a04-44f0-8dd8-fbbc08e3bf91.png?v=1771906764',
      howToUse: 'After shampooing, apply to lengths and ends. Detangle gently. Leave 2–5 minutes. Rinse thoroughly.',
      routineStep: 'Conditioning step 2 (Weightless routine)'
    },
    'bounce-curl-volume-root-clips': {
      name: 'Bounce Curl Volume Root Clips (6-pack)',
      brand: 'Bounce Curl',
      price: 40,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-volume-root-clips',
      shortDesc: 'Clip at roots on damp hair for lift while drying — no heat needed.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/sunshine-curls-bounce-curl-volume-root-clips-brown.jpg?v=1718752500',
      howToUse: 'After applying all styling products and brushing curls, place clips at root sections on damp hair. Leave until hair is 80%+ dry, then remove gently.',
      routineStep: 'Styling (clipping phase during drying)'
    },
    'bounce-curl-wavy-curly-kit': {
      name: 'Bounce Curl Wavy Curly Define Complete Kit',
      brand: 'Bounce Curl',
      price: 188,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-wavy-curly-define-complete-kit',
      shortDesc: 'Premium all-in-one Bounce Curl experience for wavy to curly hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/sunshine-curls-bounce-curl-wavy-curly-define-complete-kit.jpg?v=1718752450',
      howToUse: 'Follow Bounce Curl routine order: leave-in → cream → gel → brush for maximum definition.',
      routineStep: 'Complete wash-day and styling routine'
    },
    'bounce-curl-satin-bonnet': {
      name: 'Bounce Curl Reversible Satin Bonnet',
      brand: 'Bounce Curl',
      price: 49.95,
      emoji: '🧡',
      url: 'https://www.sunshinecurls.com.au/products/bounce-curl-reversible-satin-bonnet',
      shortDesc: 'Budget-friendly satin sleep protection — reduces friction and morning frizz.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/125.jpg?v=1772173465',
      howToUse: 'Place over styled hair before sleeping. The satin lining reduces friction and moisture loss overnight.',
      routineStep: 'Sleep protection'
    },
    'bambonn-wrap': {
      name: 'Original BamBonn Haircare Wrap',
      brand: 'BamBonn',
      price: 45,
      emoji: '🌿',
      url: 'https://www.sunshinecurls.com.au/products/original-bambonn-haircare-wrap',
      shortDesc: '100% bamboo. Exclusive to Sunshine Curls in Australia. Overnight curl protection that actually stays on.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/original-bambonn-haircare-wrap-sleep-protection-sunshine-curls-528650.jpg?v=1718752945',
      howToUse: 'Pull wrap down over your head, bring hair out, then pull wrap up over head and hair. Fold or roll the excess fabric up and fasten with the ribbon. Make sure the fabric sits on the forehead — not just the hairline — so it stays on overnight.',
      routineStep: 'Overnight sleep protection'
    },
    'bambonn-towel': {
      name: 'BamBonn Curly Hair Towel',
      brand: 'BamBonn',
      price: 52,
      emoji: '🌿',
      url: 'https://www.sunshinecurls.com.au/products/bambonn-hair-towel',
      shortDesc: 'Bamboo towel that scrunches without frizz-causing friction. Exclusive to Sunshine Curls.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/products/bambonn-curly-hair-towel-sunshine-curls-926441.jpg?v=1718752948',
      howToUse: 'After washing, flip hair forward and gently press/scrunch — do not rub. Use before styling. You may need a little extra product after scrunching.',
      routineStep: 'Post-wash, before styling'
    },
    'skala-blue': {
      name: 'SKALA Blue Mais Cachos Treatment 1kg',
      brand: 'SKALA',
      price: 24.95,
      emoji: '💜',
      url: 'https://www.sunshinecurls.com.au/products/skala-mais-cachos-hair-treatment-conditioning-cream-blue-skala',
      shortDesc: 'The viral 1kg tub. Use as deep conditioner OR curl cream. Incredible value.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/skala-mais-cachos-hair-treatment-cream-blue-skala1.jpg?v=1770612584',
      howToUse: 'As deep treatment: apply generously to clean, wet hair after shampooing. Leave 5–20 min. Rinse. As curl cream: use a small amount on wet hair and style as usual.',
      routineStep: 'Deep conditioner or curl cream'
    },
    'skala-yellow': {
      name: 'SKALA Yellow Passionfruit Treatment 1kg',
      brand: 'SKALA',
      price: 24.95,
      emoji: '💜',
      url: 'https://www.sunshinecurls.com.au/products/skala-passionfruit-pataua-oil-hair-treatment-cream-yellow-skala',
      shortDesc: 'Moisture-focused SKALA — softer, shinier hair. Also works as a curl cream in small amounts.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/skala-passion-fruit-and-amazonian-olive-oil-2in1-hair-treatment-conditionning-cream1.jpg?v=1752558531',
      howToUse: 'Apply to clean, wet hair. Work through lengths and ends. Leave 5–20 min. Rinse well. Can also be used as a light curl cream on wet hair.',
      routineStep: 'Deep conditioner or rinse-out conditioner'
    },
    'skala-liquid-gel': {
      name: 'SKALA Day After Liquid Gel 250g',
      brand: 'SKALA',
      price: 22,
      emoji: '💜',
      url: 'https://www.sunshinecurls.com.au/products/skala-perfect-curls-day-after-liquid-gel-250ml',
      shortDesc: 'Light hold gel AND second-day refresher. At $22, the best value gel in the store.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/skala-curl-liquid-gel1.jpg?v=1753158915',
      howToUse: 'On wash day: apply to wet hair after leave-in, style as normal. On day 2–3: lightly dampen curls with water, scrunch a small amount through, and your curls come back to life.',
      routineStep: 'Styling (gel/hold layer) or day 2 refresher'
    },
    'skala-expert-gel': {
      name: 'SKALA Expert Curls Gelatine 1kg',
      brand: 'SKALA',
      price: 24.95,
      emoji: '💜',
      url: 'https://www.sunshinecurls.com.au/products/skala-hair-treatment-perfect-curls-jelly-1kg',
      shortDesc: '$27 for 1kg of strong hold gel. Extraordinary value for thick or coily hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/skala-curl-jelly-1kg-2.jpg?v=1770612584',
      howToUse: 'Apply to soaking wet hair after leave-in. Scrunch through in sections. Diffuse or air dry. Scrunch out the cast when fully dry.',
      routineStep: 'Styling step 3 — strong hold layer'
    },
    'skala-starter-kit': {
      name: 'SKALA Starter Kit — Blue Mais Cachos',
      brand: 'SKALA',
      price: 46.95,
      emoji: '💜',
      url: 'https://www.sunshinecurls.com.au/products/skala-mais-cachos-starter',
      shortDesc: 'Blue SKALA 1kg + Shampoo & Conditioner Kit. Best value complete curl routine.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/skala-starter-mais-cachos.jpg?v=1758867427',
      howToUse: 'Wash day system: shampoo → conditioner → Blue SKALA treatment. See individual product instructions for each step.',
      routineStep: 'Complete wash-day routine (budget-friendly)'
    },
    'skala-shampoo-conditioner-kit': {
      name: 'SKALA Shampoo & Conditioner Kit 325ml',
      brand: 'SKALA',
      price: 45,
      emoji: '💜',
      url: 'https://www.sunshinecurls.com.au/products/skala-mais-cachos-perfect-curls-shampoo-conditioner-kit-325ml',
      shortDesc: 'Sulfate-free curl-safe shampoo & conditioner — the natural companion to SKALA Blue.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/skala-perfect-curls-shampoo-and-conditioner-kit.jpg?v=1753159913',
      howToUse: 'Shampoo: wet hair, apply, lather gently, rinse. Conditioner: apply to lengths and ends, leave 2–3 min, rinse. Follow with Blue SKALA treatment for best results.',
      routineStep: 'Wash day steps 1 & 2'
    },
    'tootilab-ultimate-curly-set': {
      name: 'Tootilab Ultimate Curly Set',
      brand: 'Tootilab',
      price: 255,
      emoji: '🔵',
      url: 'https://www.sunshinecurls.com.au/products/tootilab-ultimate-curly-set',
      shortDesc: 'The complete wash-day system. Shampoo → Conditioner → Leave-In → Gel. Perfect for beginners.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/Full_lineup_plaster_copy_6237b655-c685-4dbc-863a-07467e0423a1.jpg?v=1729215511',
      howToUse: 'Use as a complete wash-day system in order: shampoo → condition → leave-in → gel. Follow individual product instructions for each step.',
      routineStep: 'Complete wash-day routine'
    },
    'tootilab-styling-set': {
      name: 'Tootilab Styling Set ($136)',
      brand: 'Tootilab',
      price: 136,
      emoji: '🔵',
      url: 'https://www.sunshinecurls.com.au/products/tootilab-styling-set',
      shortDesc: 'Soft Leave-In + All Weather Gel. Great entry point — comes in trial and full size.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/Stylingbundle_hero.jpg?v=1729215988',
      howToUse: 'Apply Leave-In to wet hair first, then layer Gel over the top. Scrunch and style. Use with Bounce Curl brushes for best definition.',
      routineStep: 'Styling steps 1 & 3 combined'
    },
    'tootilab-all-weather-gel': {
      name: 'Tootilab All Weather Styling Gel',
      brand: 'Tootilab',
      price: 68,
      emoji: '🔵',
      url: 'https://www.sunshinecurls.com.au/products/tootilab-all-weather-styling-gel-300ml',
      shortDesc: 'Medium-strong hold with built-in heat protection. Works on all hair types. Incredible shine.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/tootilab-all-weather-styling-gel-1.jpg?v=1726721017',
      howToUse: 'Apply to soaking wet hair after leave-in or cream. Use Bounce Curl brushes for best definition. Scrunch in sections. Diffuse or air dry. Scrunch out the cast when completely dry.',
      routineStep: 'Styling step 3 — final hold layer'
    },
    'tootilab-soft-leave-in': {
      name: 'Tootilab Soft Leave-In Cream',
      brand: 'Tootilab',
      price: 68,
      emoji: '🔵',
      url: 'https://www.sunshinecurls.com.au/products/tootilab-soft-leave-in-cream-300ml',
      shortDesc: 'Ultra-concentrated leave-in — start with a pea-size. Creates incredibly soft, moisturised curls.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/tootilab-soft-leave-in-cream-1.jpg?v=1726720749',
      howToUse: 'Start with pea-to-blueberry size. Emulsify well in palms until hands look white. Apply to soaking wet hair. Hair should feel slightly slippery. Build up gradually.',
      routineStep: 'Styling step 1 — leave-in layer'
    },
    'lohy-pow-gel': {
      name: 'LOHY POW Strong Hold Gel',
      brand: 'LOHY',
      price: 46,
      emoji: '🤍',
      url: 'https://www.sunshinecurls.com.au/products/lohy-pow-strong-hold-gel',
      shortDesc: '100% Australian-made. Strong hold. The peppermint scent disappears when dry.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/LOHY-pow-strong-hold-gel.jpg?v=1739844513',
      howToUse: 'Apply to soaking wet hair after leave-in or cream. Rake and scrunch through sections. Diffuse or air dry. Scrunch out the cast when fully dry.',
      routineStep: 'Styling step 3 — strong hold layer'
    },
    'lohy-cruise-control-cream': {
      name: 'LOHY Cruise Control Curl Cream',
      brand: 'LOHY',
      price: 45,
      emoji: '🤍',
      url: 'https://www.sunshinecurls.com.au/products/lohy-cruise-control-curl-cream',
      shortDesc: '100% Australian-made. Doubles as a leave-in. Orange/mandarin scent. Apply before gel.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/LOHY-cruise-control-curl-cream.jpg?v=1739856691',
      howToUse: 'Mist damp hair. Apply a small amount through frizzy curl sections. Can be used as a leave-in. Apply before gel for best results — primes the hair shaft before hold.',
      routineStep: 'Styling step 2 — curl cream/primer before gel'
    },
    'lohy-chutzpah-foam': {
      name: 'LOHY Chutzpah Volumising Foam',
      brand: 'LOHY',
      price: 50,
      emoji: '🤍',
      url: 'https://www.sunshinecurls.com.au/products/lohy-chutzpah-volumising-foam-200ml',
      shortDesc: '100% Australian-made. Apply AFTER gel — this surprises people but it works. Volume + sun protection.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/LOHY-chutzpah-volumizing-foam.jpg?v=1739857810',
      howToUse: 'Apply AFTER your styling gel on dripping wet hair. Pump 1–3 times per side. Tilt head, lift curl section to scalp and pulse-scrunch 3–4 times. Clip roots and diffuse or air dry. Also works on dry hair for volume refresh between washes.',
      routineStep: 'Styling step 4 — AFTER gel (volume boost)'
    },
    'ecoslay-orange-marmalade': {
      name: 'Ecoslay Orange Marmalade Curl Definer',
      brand: 'Ecoslay',
      price: 35,
      emoji: '🍊',
      url: 'https://www.sunshinecurls.com.au/products/ecoslay-orange-marmalade-flaxseed-and-aloe-curl-definer-236ml',
      shortDesc: 'Handmade, natural-first. Flaxseed gel base for incredible definition. Refrigerate after opening.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/products/ecoslay-orange-marmalade-flaxseed-and-aloe-curl-definer-236ml-sunshine-curls-289816.webp?v=1718752715',
      howToUse: 'Apply liberally to soaking wet hair. Rake and scrunch in sections. Air dry or diffuse. Can use alone or layer Jello Shot over the top for more hold. ⚠️ Keep refrigerated after opening.',
      routineStep: 'Styling step 1–2 — leave-in/curl definer'
    },
    'ecoslay-jello-shot': {
      name: 'Ecoslay Jello Shot Curl Defining Gel',
      brand: 'Ecoslay',
      price: 49,
      emoji: '🍊',
      url: 'https://www.sunshinecurls.com.au/products/ecoslay-jello-shot-curl-defining-gel',
      shortDesc: 'Strong hold, natural ingredients. Glaze over Orange Marmalade for longer-lasting style.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/products/ecoslay-jello-shot-curl-defining-gel-strong-hold-473ml-sunshine-curls-940556.webp?v=1718752714',
      howToUse: 'Apply to wet hair after Orange Marmalade or leave-in. Glaze over the top of other products for extra hold and longevity. Scrunch in sections. ⚠️ Keep refrigerated after opening.',
      routineStep: 'Styling step 3 — strong hold layer over Orange Marmalade'
    },
    'ecoslay-banana-cream': {
      name: 'Ecoslay Banana Cream Deep Conditioner',
      brand: 'Ecoslay',
      price: 35,
      emoji: '🍊',
      url: 'https://www.sunshinecurls.com.au/products/ecoslay-banana-cream-deep-conditioner-473ml',
      shortDesc: 'Handmade deep conditioner. Okra extract = incredible detangling slip. Refrigerate after opening.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/products/ecoslay-banana-cream-deep-conditioner-473ml-sunshine-curls-247763.webp?v=1718752714',
      howToUse: 'Apply a generous amount to soaking wet hair after cleansing. Leave 30 minutes using a heat cap for deep penetration. Rinse. Can also be used as a leave-in for extra-dry hair. ⚠️ Keep refrigerated after opening.',
      routineStep: 'Deep conditioning treatment (weekly)'
    },
    'rizos-curl-defining-cream': {
      name: 'Rizos Curls Curl Defining Cream',
      brand: 'Rizos Curls',
      price: 43,
      emoji: '🤎',
      url: 'https://www.sunshinecurls.com.au/products/rizos-curls-curl-defining-cream',
      shortDesc: 'Award-winning. Protein-free. Works on all curl types. Great for dry hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/rizos-curls-curl-defining-cream-3.jpg?v=1746186084',
      howToUse: 'Apply a quarter-size amount to wet hair. Work from roots to ends. Scrunch and use fingers to shape curls. On fine hair, use sparingly.',
      routineStep: 'Styling step 2–3 — curl cream/definer'
    },
    'rizos-strong-hold-gel': {
      name: 'Rizos Curls Strong Hold Gel',
      brand: 'Rizos Curls',
      price: 45,
      emoji: '🤎',
      url: 'https://www.sunshinecurls.com.au/products/rizos-curls-strong-hold-gel',
      shortDesc: 'Strong hold, no crunch. Protein-free. Pairs beautifully with Rizos Cream.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/rizos-curls-strong-hold-gel-1.png?v=1760332143',
      howToUse: 'Apply to wet hair after cream. Smooth and scrunch through sections. Diffuse or air dry. Scrunch out cast when fully dry.',
      routineStep: 'Styling step 3 — strong hold layer'
    },
    'rizos-hydrating-shampoo': {
      name: 'Rizos Curls Hydrating Shampoo',
      brand: 'Rizos Curls',
      price: 43,
      emoji: '🤎',
      url: 'https://www.sunshinecurls.com.au/products/rizos-curls-hydrating-shampoo',
      shortDesc: 'Protein-free, sulfate-free. Award-winning. Latin-owned brand.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/rizos-curls-hydrating-shampoo.jpg?v=1746186084',
      howToUse: 'Apply to wet scalp and hair. Lather gently and rinse thoroughly. Follow with Rizos Deep Conditioner.',
      routineStep: 'Wash step 1'
    },
    'rizos-deep-conditioner': {
      name: 'Rizos Curls Deep Conditioner',
      brand: 'Rizos Curls',
      price: 43,
      emoji: '🤎',
      url: 'https://www.sunshinecurls.com.au/products/rizos-curls-deep-conditioner',
      shortDesc: 'Rich but not heavy. Use as rinse-out (5 min) or deep treatment (30 min). Protein-free.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/rizos-curls-deep-conditioner.jpg?v=1746186084',
      howToUse: 'After shampooing, apply thoroughly to wet hair. Detangle gently. Leave 5–10 minutes (or up to 30 min as a mask). Rinse thoroughly.',
      routineStep: 'Conditioning step 2 (or deep treatment)'
    },
    'flora-curl-foam': {
      name: 'Flora & Curl Sweet Hibiscus Volumizing Foam',
      brand: 'Flora & Curl',
      price: 47,
      emoji: '🌸',
      url: 'https://www.sunshinecurls.com.au/products/flora-curl-sweet-hibiscus-volumizing-foam',
      shortDesc: 'Dual-use: wash day volume booster AND between-washes refresher. Award-winning.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/whitebackground-flora-curl-VolumisingFoam.jpg?v=1741404327',
      howToUse: 'Wash day: apply 1–3 pumps to damp hair after styling products, scrunch to encourage curl formation. Between washes: apply lightly to dry hair at roots to refresh volume.',
      routineStep: 'Styling step 3–4 (after cream/gel, or between washes)'
    },
    'puff-cuff-junior': {
      name: 'Puff Cuff Junior Hair Clamp 3 Inch (2-pack)',
      brand: 'Puff Cuff',
      price: 32,
      emoji: '⭕',
      url: 'https://www.sunshinecurls.com.au/products/puff-cuff-junior-clear-pack-hair-clamp-3-inch-2-pcs',
      shortDesc: 'Damage-free ponytail tool. Gather hair FIRST, then clamp — do not slide through.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/puff-cuff-hair-clamp-junior-black-3.png?v=1761027750',
      howToUse: 'Gather hair as if making a ponytail. INSERT (not glide) the teeth of one arm into hair at the base of the puff, close to scalp. Insert opposite arm. Push arms toward each other to overlap hooks. Pull apart gently to interlock and close.',
      routineStep: 'Styling — updo/ponytail/half-up'
    },
    '360-curly-hair-kit': {
      name: '360° Curly Hair Kit ($200)',
      brand: 'Mixed',
      price: 200,
      emoji: '⭐',
      url: 'https://www.sunshinecurls.com.au/products/360-curly-hair-kit',
      shortDesc: 'All-in-one bestseller kit covering the complete curl routine. Perfect for beginners.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/sunshine-curls-360-curly-hair-kit-6.jpg?v=1772422292',
      howToUse: 'Follow the routine order included in the kit from wash through to styling.',
      routineStep: 'Complete wash-day routine'
    },
    'pretty-curly-girl-protein-mask': {
      name: 'Pretty Curly Girl Intense Protein Mask',
      brand: 'Pretty Curly Girl',
      price: 44.95,
      emoji: '✨',
      url: 'https://www.sunshinecurls.com.au/products/pretty-curly-girl-intense-protein-deep-conditioner',
      shortDesc: 'Intensive protein treatment for damaged, bleached, or breakage-prone hair.',
      image: 'https://cdn.shopify.com/s/files/1/0674/7127/8299/files/pretty-curly-girl-intense-protein-deep-conditioner_6cf512b6-65be-4fe0-88d1-1edcd5aa2504.jpg?v=1762343148',
      howToUse: 'Apply to clean, wet hair. Leave 15–30 minutes. Rinse thoroughly. Follow with a moisturising deep conditioner to balance.',
      routineStep: 'Treatment step — protein mask'
    }
  };

  // ============================================================
  // SYSTEM PROMPT — Full knowledge base for the AI
  // ============================================================
  const SYSTEM_PROMPT = `You are Lily — the Sunshine Curls shopping assistant and a warm, expert friend who genuinely knows curly hair. Your name is Lily. You help customers find the right products for their hair. Sunshine Curls is an Australian online store. The founder, Yasna, has thick, unruly, frizzy curls herself and built this store from personal experience. You speak the way Yasna would — knowledgeable, direct, warm, never salesy or generic.

================================================================
// ---- KNOWLEDGE BASE START ----
================================================================
PRODUCT KNOWLEDGE BASE — generated from Lily_Knowledge_Base.xlsx
To update: edit the spreadsheet and ask Claude to rebuild from it.
================================================================

── Bounce Curl Define EdgeLift Styling Brush ──
Brand: Bounce Curl
Price: $50.00
Category: Tool / Brush
Hold Level: N/A (tool)
Hair Concerns: Frizz; lack of definition; undefined curl clumps
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Boar bristle; wider-spaced ridges; high tension
Free From: 
How To Use: Apply styling products to soaking wet hair. Section and brush through with tension, pushing hair up through the ridges to form defined curl clumps. Scrunch after.
Routine Step: Styling — use after leave-in & cream/gel
Pairs Well With: Bounce Curl Avocado Cream; SKALA Blue; Tootilab All Weather Gel; BamBonn Wrap
Beginner Friendly: Yes — universal
Special Warnings: NOT for damaged, bleached, or breakage-prone hair. High tension. BEST for ultimate definition and frizz control.
AI Notes: THE #1 hero product. Boar bristle, high tension. Wider ridges = THICKER curl clumps. Recommend for definition and frizz on healthy hair. Always pair with a cream or gel. Designed to give a defined curl by smoothing out the frizz with the boar bristles and then creating juicy curl clumps with the wider ridges. The way to recommend this brush is if the customer asks for frizz control and does not have damaged hair, or if they care more about definition than anything else.

── Bounce Curl Volume EdgeLift Styling Brush ──
Brand: Bounce Curl
Price: $52.00
Category: Tool / Brush
Hold Level: N/A (tool)
Hair Concerns: Flat roots; lacking volume; curls going limp
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Boar bristle; thinner/closer-spaced ridges; high tension
Free From: 
How To Use: Apply styling products to soaking wet hair. Work with head tilted forward for root lift. Pull through brush — creates thinner clumps that stack for volume.
Routine Step: Styling — use after leave-in & cream/gel
Pairs Well With: Bounce Curl Volume Root Clips; any cream and gel combo
Beginner Friendly: Yes
Special Warnings: NOT for damaged or bleached hair. Same high tension as Define Brush. BEST for volume and definition combo.
AI Notes: Boar bristle, same high tension as Define Brush. THINNER ridges = thinner clumps that stack on top of each other for LIFT and VOLUME. The ONLY difference from Define Brush is ridge spacing. Define = wider ridges + thicker clumps; Volume = thinner ridges + thinner clumps + lift. For customers that want more volume but also definition, this is the brush for them.

── Bounce Curl Slick-Flex Define EdgeLift Brush ──
Brand: Bounce Curl
Price: $50.00
Category: Tool / Brush
Hold Level: N/A (tool)
Hair Concerns: Fragile or breakage-prone hair needing definition; scalp sensitivity
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Ultra-soft TPEE bristles (rapeseed oil); low tension; one-and-done
Free From: 
How To Use: Apply styling products to wet hair. Using very light pressure, glide brush through each section. Detangles AND styles in one step — no separate detangling needed.
Routine Step: Styling + detangling in one step
Pairs Well With: Bounce Curl Avocado Cream; Ceramide Jelly; BamBonn Wrap
Beginner Friendly: Yes — safest brush for fragile hair
Special Warnings: LOWEST tension of all four brushes. For severely damaged, bleached, breakage-prone hair ONLY. some definition but less than boar bristle alteratives.
AI Notes: TPEE soft bristles, NOT boar. One-and-done: detangles AND styles in one pass. Lowest tension in the range. For bleached, severely damaged, fragile, or breakage-prone hair. Also great for short hair (bobs, pixie) as the brush width is narrower so easy to get around shorter hair. NEVER recommend standard Define Brush when customer mentions breakage or bleaching.

── Bounce Curl Slick-Dense Define EdgeLift Brush ──
Brand: Bounce Curl
Price: $50.00
Category: Tool / Brush
Hold Level: N/A (tool)
Hair Concerns: Colour-treated or lightly damaged hair; tension sensitivity
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Medium-density TPEE bristles; medium tension; one-and-done
Free From: 
How To Use: Apply styling products to wet hair. Detangles AND styles in one step — no separate detangling needed. Divide into half-inch sections and glide through.
Routine Step: Styling + detangling in one step
Pairs Well With: Bounce Curl Avocado Cream; Light Creme Gel; BamBonn Wrap
Beginner Friendly: Yes — great middle-ground
Special Warnings: Medium tension — less definition than Define/Volume, more than Slick-Flex.
AI Notes: TPEE soft bristles, NOT boar. One-and-done: detangles AND styles in one pass. MEDIUM tension — less than Define/Volume boar brushes, more than Slick-Flex. Best for colour-treated or lightly damaged hair that cannot handle boar bristle tension. Tension scale: Slick-Flex (lowest) → Slick-Dense → Define/Volume (highest). Great option for people that want definition but in a slightly more gentle brush than the boar bristle originals.

── Bounce Curl High Definition Bundle ──
Brand: Bounce Curl
Price: $145.00
Category: Bundle
Hold Level: Light hold
Hair Concerns: Frizz; lack of definition; wanting a complete styling routine
Best For Curl Type: Wavy 2B–2C; Curly 3A–3C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Define Brush + Avocado Cream + Light Creme Gel
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply cream to wet hair, then gel, then brush through for defined clumps. Scrunch and diffuse or air dry.
Routine Step: Complete styling routine
Pairs Well With: BamBonn Wrap; Bounce Curl Moisture Balance Leave-In; Volume Root Clips
Beginner Friendly: Yes — perfect starter kit
Special Warnings: Contains protein (Light Creme Gel). Not ideal for protein-sensitive hair. Great light hold mid-range bundle.
AI Notes: Best value Bounce Curl entry point. LIGHT hold only and good moisture. Gel is light hold, cream is for moisture. Both the stylers have heat protection built in — if customer wants stronger hold, recommend Weightless Collection or Tootilab bundle instead. Good for fine hair due to protein content. The gel also is 20% cream and 80% gel, so its a moisturising gel.  Great starter bundle as contains the brush, gel and cream which is enough to get started.

── Bounce Curl Weightless Collection Full Set ──
Brand: Bounce Curl
Price: $240.00
Category: Bundle
Hold Level: Medium hold (lightweight)
Hair Concerns: Fine hair needing volume; wanting premium lightweight complete routine
Best For Curl Type: Wavy 2A–2C; Curly 3A–3B
Best For Texture: Fine, Medium
Key Ingredients: Full Weightless system — Volunix Bio-Actives; featherlight polymers
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Use as complete routine in order: shampoo → conditioning mask → leave-in → ceramide jelly or hydra-lite cream.
Routine Step: Complete volume-focused routine
Pairs Well With: Bounce Curl Volume Root Clips; BamBonn Wrap; Volume Brush
Beginner Friendly: Yes — specifically for fine or volume-seeking hair
Special Warnings: The go to range for volume seeking people or fine haired curlies, ultimate range. Premium if purchased as a full set.
AI Notes: Premium/best bundle option for fine hair or anyone wanting volume and lightweight hold. Not exclusive to fine hair — anyone wanting volume can use it. Hydration + hold in featherlight finish.

── Bounce Curl Weightless Styling Duo ──
Brand: Bounce Curl
Price: $96.00
Category: Bundle
Hold Level: Medium hold (lightweight)
Hair Concerns: Fine hair needing definition without weight; wanting leave-in + gel in one purchase
Best For Curl Type: Wavy 2A–2C; Curly 3A–3B
Best For Texture: Fine, Medium
Key Ingredients: Thermal Guard Leave-In + Ceramide Jelly
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply Thermal Guard Leave-In to damp hair first. Layer Ceramide Jelly over the top. Scrunch and diffuse or air dry. Scrunch out cast when completely dry.
Routine Step: Styling steps 1 & 3 combined (Weightless routine)
Pairs Well With: Bounce Curl Volume Brush; Volume Root Clips; Weightless Shampoo
Beginner Friendly: Yes
Special Warnings: fine haired/volume seeking medium-firm hold set.
AI Notes: Thermal Guard doubles as heat protectant — key selling point for diffusers. Medium hold, humidity resistant. Good entry point into the Weightless range without buying the full set.

── Bounce Curl Ceramide Jelly ──
Brand: Bounce Curl
Price: $49.95
Category: Gel / Styler
Hold Level: Medium hold
Hair Concerns: Frizz in humidity; fine hair needing hold without crunch; colour-treated hair
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium
Key Ingredients: Ceramides; medium-hold polymers; humidity-resistant agents
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply to wet hair after leave-in. Smooth and scrunch through sections. Diffuse or air dry. Scrunch out cast when completely dry.
Routine Step: Styling step 3 — hold layer (Weightless routine)
Pairs Well With: Thermal Guard Leave-In; Volume Brush; Volume Root Clips
Beginner Friendly: Yes
Special Warnings: fine haired/volume seeking medium-firm hold gel.
AI Notes: Ceramides repair and strengthen cuticle — excellent for colour-treated or fine damaged hair. Medium hold + humidity resistance. Has a lightweight but medium stregnth cast which is easily broken. Jelly like consistency, lots of slip, easy to apply and distribute with the hair. Pair with one of the Bounce Curl brushes depending on desired result, and hair health.

── Bounce Curl Avocado & Rose Oil Curl Cream ──
Brand: Bounce Curl
Price: $49.00
Category: Curl Cream
Hold Level: Light-medium hold
Hair Concerns: Frizz; dryness; lack of definition; dull curls
Best For Curl Type: Wavy 2B–2C; Curly 3A–3C; Coily 4A
Best For Texture: Medium, Coarse
Key Ingredients: Avocado oil; rose oil; natural botanicals
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply to soaking wet hair in sections. Rake through and scrunch. Emulsify in palms first. Use alone for moisture OR layer under gel for hold.
Routine Step: Styling step 2 — after leave-in, before gel
Pairs Well With: Bounce Curl Define Brush; Light Creme Gel; BamBonn Wrap
Beginner Friendly: Yes — bestselling cream
Special Warnings: protein free, bestselling, 20% hold 80% moisture.
AI Notes: Bestselling curl cream. Medium moisture + light-medium hold. Softness and definition without stiffness. Best on medium to coarse hair. For fine hair, suggest Weightless Hydra-Lite Cream instead. Built in heat protection. Emulsify very well before applying as the cream is concentrated - only provide this information if the customer wants instructions on how to use it.

── Bounce Curl Moisture Balance Leave-In Conditioner ──
Brand: Bounce Curl
Price: $48.00
Category: Leave-In Conditioner
Hold Level: N/A (leave-in)
Hair Concerns: Dryness; frizz; lack of moisture
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Ultra-concentrated botanical moisturisers; frizz-sealing actives
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Start with a PEA-TO-BLUEBERRY SIZE AMOUNT ONLY. Emulsify in palms until they look white. Apply to soaking wet hair. Hair should feel slightly slippery.
Routine Step: Styling step 1 — leave-in/moisture layer
Pairs Well With: Bounce Curl Light Creme Gel; Define Brush
Beginner Friendly: Yes — warn about concentration
Special Warnings: ULTRA-CONCENTRATED. Always warn: start with pea-size and build up or customer will think they used too much.
AI Notes: Ultra-concentrated hair moisturiser and primer— a tiny amount goes a very long way. ALWAYS warn customers to start with pea-size. Core part of Wavy Curly Define Complete Kit. Pair with the LIght Creme Gel for more hold (will still only provide light hold) or with the Avocado Cream for more moisture for dry hair. On it's own this product does not have any hold and only has moisturising properties to it.

── Bounce Curl Weightless Conditioning Mask 296ml ──
Brand: Bounce Curl
Price: $49.95
Category: Deep Conditioner
Hold Level: N/A (conditioner)
Hair Concerns: Fine hair needing moisture without weight; dryness on fine strands
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium
Key Ingredients: Lightweight hydrating actives; Volunix Bio-Actives
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: After shampooing, apply to lengths and ends. Detangle gently. Leave 2–5 min. Rinse thoroughly.
Routine Step: Conditioning step 2 (Weightless routine)
Pairs Well With: Weightless Shampoo; Thermal Guard Leave-In; Ceramide Jelly
Beginner Friendly: Yes
Special Warnings: deep conditioning mask suitable for fine hair, hair that gest easily weighed down.
AI Notes: Hydrates without ANY heaviness — genuine problem-solver for fine-haired customers who find regular conditioners flatten their curls. Recommend as part of the full Weightless routine, not standalone.

── Bounce Curl Volume Root Clips (6-pack) ──
Brand: Bounce Curl
Price: $40.00
Category: Accessory
Hold Level: N/A (accessory)
Hair Concerns: Flat roots; no volume at crown; curl definition falling out during drying
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Lightweight custom-moulded clip; smooth curl-safe edges
Free From: 
How To Use: After styling, place clips at root sections on damp hair. Leave until hair is 80%+ dry, then remove gently.
Routine Step: Clipping phase during drying
Pairs Well With: Define Brush; Volume Brush; any styling products
Beginner Friendly: Yes — easy instant upgrade
Special Warnings: people that want root lift or more volume, pair with bounce curl volume brush
AI Notes: Natural upsell any of the four bounce curl brushes, but in particular the volume brush as the customer already wants more volume. Great for wash-and-go. Provides root lift while the hair is drying. Alternative to diffusing for volume without heat. Low cost, highly visible result.

── Bounce Curl Wavy Curly Define Complete Kit ──
Brand: Bounce Curl
Price: $188.00
Category: Bundle
Hold Level: Light-medium hold
Hair Concerns: Complete routine for wavy to curly hair; frizz; dryness
Best For Curl Type: Wavy 2A–2C; Curly 3A–3B
Best For Texture: Fine, Medium
Key Ingredients: Full Bounce Curl system: brush, leave-in, cream, gel
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Follow Bounce Curl routine: leave-in → cream → gel → brush for maximum definition.
Routine Step: Complete wash-day and styling routine
Pairs Well With: BamBonn Wrap; Volume Root Clips
Beginner Friendly: Yes — mid-range complete starter kit
Special Warnings: Contains protein. Not ideal for protein-sensitive hair. Best for wavy to curly (2A–3B), not coily.
AI Notes: Mid-range all-in-one for wavy to curly hair. Contains protein — good for fine hair structure. For coarser/drier hair or coily, recommend Tootilab Ultimate Set instead.This is classed as mid-range as the individual items are mid-range and the price only seems high becuase it is a bundle.

── Bounce Curl Reversible Satin Bonnet ──
Brand: Bounce Curl
Price: $49.95
Category: Sleep Accessory
Hold Level: N/A (accessory)
Hair Concerns: Morning frizz from sleeping; curl flattening overnight
Best For Curl Type: All curl types
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Satin lining; reversible design; gentle elastic
Free From: 
How To Use: Place over styled hair before sleeping. The satin lining reduces friction and moisture loss overnight.
Routine Step: Sleep protection
Pairs Well With: BamBonn Wrap (alternative); any styling products
Beginner Friendly: Yes
Special Warnings: 
AI Notes: Budget-friendly alternative to Silk bonnets. Satin (not silk/bamboo). Has more space than BamBonn which is a tighter tubular fit. Recommend when customer wants a more spacious type of sleep protection or wants a silk-like feel but without the silk premium price tag. Has an adjustable elastic strap and reversible pattern. Luxurious feel for the price point. Not as breathable as it is satin, not bamboo like the bambonn wrap.

── Original BamBonn Haircare Wrap ──
Brand: BamBonn
Price: $45.00
Category: Accessory / Hair Wrap
Hold Level: N/A (accessory)
Hair Concerns: Frizz from friction overnight; curl flattening during sleep
Best For Curl Type: All curl types
Best For Texture: Fine, Medium, Coarse
Key Ingredients: 100% bamboo fibre; ultra-soft; breathable
Free From: 
How To Use: Pull wrap down over head, bring hair out, then pull wrap back up over head and hair. Fold/roll excess fabric and fasten with ribbon. Fabric must sit on forehead (not just hairline) so it stays on overnight.
Routine Step: Overnight sleep protection
Pairs Well With: Any styling products — works independently
Beginner Friendly: Yes — zero learning curve
Special Warnings: EXCLUSIVE to Sunshine Curls in Australia. Breathable fabric, affordable sleep protection.
AI Notes: EXCLUSIVE to Sunshine Curls in Australia — ALWAYS mention this. 100% bamboo = softer and more breathable than cotton/satin. Universal add-on — recommend with every order. Variants: Black, Grey, Teal, Rose, Forest, Mint, Gingerbread, White. Kids versions available. Has a snug, protective fit whilst still remaining breathable. Suitable for long or short curly hair.

── BamBonn Curly Hair Towel ──
Brand: BamBonn
Price: $52.00
Category: Accessory / Towel
Hold Level: N/A (accessory)
Hair Concerns: Frizz from terry cloth towel drying; long drying times
Best For Curl Type: All curl types
Best For Texture: Fine, Medium, Coarse
Key Ingredients: 100% bamboo fibre; ultra-absorbent; smooth texture
Free From: 
How To Use: After washing, flip hair forward and gently press/scrunch — do NOT rub. Use before styling. May need a little extra product after scrunching as towel absorbs some.
Routine Step: Post-wash, before styling
Pairs Well With: BamBonn Wrap; Define Brush; any styling products
Beginner Friendly: Yes
Special Warnings: Scrunching removes some product — remind customer to add a little extra after.
AI Notes: EXCLUSIVE to Sunshine Curls alongside the Wrap. Different from Wrap: Towel = quick drying/scrunching tool; Wrap = overnight sleep protection. Great bundle: Towel + Wrap together. Towel is used to take out excess water from the hair to help reduce drying time. The fabric is smooth and not like terry cotton, so no friction against delicate hair strands thus resulting in less frizz. After scrunching gently with the towel, advise to add in a fraction more product to ensure excess product has not been removed (important for customers that have excess frizz and need more product to control their hair).

── SKALA Blue Mais Cachos Treatment 1kg ──
Brand: SKALA
Price: $24.95
Category: Deep Conditioner / Treatment
Hold Level: N/A (treatment/cream)
Hair Concerns: Dryness; frizz; lack of definition; wanting curl-boosting deep treatment
Best For Curl Type: Curly 3A–3C; Coily 4A–4C; Wavy 2B–2C
Best For Texture: Medium, Coarse
Key Ingredients: Brazilian botanical actives; deep conditioning agents
Free From: Sulfate-free; silicone-free; paraben-free; vegan
How To Use: As deep treatment: apply generously to clean wet hair, leave 5–20 min, rinse. As curl cream: use small amount on wet hair and style as usual.
Routine Step: Deep conditioner OR rinse-out conditioner OR curl cream
Pairs Well With: SKALA Shampoo & Conditioner Kit; SKALA Expert Gel; Bounce Curl Define Brush
Beginner Friendly: Yes — cult favourite, amazing value
Special Warnings: AFFORDABLE range only. Never recommend as primary to mid-range or premium customers. all rounder bestselling conditioner/curl cream hybrid. Light hold cream.
AI Notes: Best-selling by UNITS. Viral globally. $24.95 for 1kg — incredible value. Hybrid product: deep conditioner + rinse-out + curl cream in one tub. Lasts months. AFFORDABLE range only. Use liberally in the shower to achieve hydrated, slippery curls. Use a fraction as a curl cream to add moisture and hold. Lightweight, suitable for fine haired curlies.

── SKALA Yellow Passionfruit Treatment 1kg ──
Brand: SKALA
Price: $24.95
Category: Deep Conditioner / Treatment
Hold Level: N/A (treatment)
Hair Concerns: Dryness; lack of shine; brittle or limp hair
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Passionfruit oil; Patauá oil; Vitamins A & C
Free From: Sulfate-free; silicone-free; paraben-free; vegan
How To Use: Apply to clean wet hair. Work through lengths and ends. Leave 5–20 min. Rinse well. Can also be used as a light curl cream in small amounts.
Routine Step: Deep conditioner or rinse-out conditioner
Pairs Well With: Define Brush; Volume Brush; any gel
Beginner Friendly: Yes
Special Warnings: AFFORDABLE range only. Heavier and more moisturising skala for dry hair types. Light hold cream.
AI Notes: Moisture-focused SKALA — for curls that are dry and need slighyl heavier moisture than the Blue. . Recommend for dry, dull, or brittle hair that does not get weighed down easily (requires extra moisture). Pairs with SKALA gel for definition. AFFORDABLE range only. Can be used as a curl cream and as a conditioner/deep conditioner. product does not have heat protection built in, can pair with the Rizos Multi-vitamin leave in conditioner if this is a must.

── SKALA Day After Liquid Gel 250g ──
Brand: SKALA
Price: $22.00
Category: Gel / Refresher
Hold Level: Light hold
Hair Concerns: Wanting affordable light hold gel; second-day frizz; refreshing curls between washes
Best For Curl Type: Curly 3A–3C; Coily 4A–4C; Wavy 2B–2C
Best For Texture: Medium, Coarse
Key Ingredients: Curl-reviving liquid gel formula; refreshing botanicals
Free From: Sulfate-free; silicone-free; paraben-free; vegan
How To Use: Wash day: apply to wet hair after leave-in, style normally. Day 2–3: lightly dampen curls, scrunch a small amount through and curls revive.
Routine Step: Styling (light hold) OR day 2+ refresher
Pairs Well With: SKALA Blue; SKALA Shampoo Kit; Define Brush
Beginner Friendly: Yes — very affordable, easy to use
Special Warnings: AFFORDABLE range only. Light hold only.
AI Notes: Best value gel in store at $22. Unique liquid texture revives curls without restarting full routine. Great add-on to any SKALA purchase. AFFORDABLE range only. Very lightweight, light flexible hold.

── SKALA Expert Curls Gelatine 1kg ──
Brand: SKALA
Price: $24.95
Category: Gel / Styler
Hold Level: Strong hold
Hair Concerns: Lack of hold; wanting strong curl definition on a budget
Best For Curl Type: Curly 3A–3C; Coily 4A–4C
Best For Texture: Medium, Coarse
Key Ingredients: Curl-setting gelatine formula; strong-hold botanicals
Free From: Sulfate-free; silicone-free; paraben-free; vegan
How To Use: Apply to soaking wet hair after leave-in. Scrunch through in sections. Diffuse or air dry. Scrunch out cast when fully dry.
Routine Step: Styling step 3 — strong hold layer
Pairs Well With: SKALA Blue; SKALA Shampoo Kit; Define Brush
Beginner Friendly: Yes — extraordinary value at $24.95 for 1kg
Special Warnings: AFFORDABLE range only. Strong hold gel.
AI Notes: $24.95 for 1kg of strong-hold gel is extraordinary value. Best for coarser or coily hair wanting strong hold on a budget. AFFORDABLE range only.

── SKALA Starter Kit — Blue Mais Cachos ──
Brand: SKALA
Price: $46.95
Category: Bundle
Hold Level: N/A (bundle)
Hair Concerns: Wanting affordable complete curl routine; beginners on a budget
Best For Curl Type: Curly 3A–3C; Coily 4A–4C; Wavy 2B–2C
Best For Texture: Medium, Coarse
Key Ingredients: Blue SKALA 1kg + SKALA Shampoo & Conditioner Kit
Free From: Sulfate-free; silicone-free; paraben-free; vegan
How To Use: Shampoo → conditioner → Blue SKALA treatment. See individual product steps.
Routine Step: Complete wash-day routine (budget-friendly)
Pairs Well With: Bounce Curl Define Brush; BamBonn Wrap
Beginner Friendly: Yes — best value entry point
Special Warnings: AFFORDABLE range only. Light or firm hold depending on what gel they select.
AI Notes: Best affordable entry point for budget-conscious customers wanting a full routine. AFFORDABLE range only. Contains a gel and a cream. Has the viral bestselling blue skala which works on most hair types, slippery, hydrating, lightweight. Pairs with either the strong hold gel or the light hold gel - customer can decide which one on the starter kit product page.

── SKALA Shampoo & Conditioner Kit 325ml ──
Brand: SKALA
Price: $45.00
Category: Shampoo & Conditioner Kit
Hold Level: 
Hair Concerns: Wanting affordable curl-safe shampoo and conditioner
Best For Curl Type: Curly 3A–3C; Coily 4A–4C; Wavy 2B–2C
Best For Texture: Medium, Coarse
Key Ingredients: Curl-safe cleansing agents; SKALA botanical actives
Free From: Sulfate-free; silicone-free; paraben-free; vegan
How To Use: Shampoo: wet hair, apply, lather gently, rinse. Conditioner: apply to lengths and ends, leave 2–3 min, rinse. Follow with Blue SKALA treatment for best results.
Routine Step: Wash steps 1 & 2
Pairs Well With: SKALA Blue 1kg; Define Brush
Beginner Friendly: Yes
Special Warnings: 
AI Notes: Natural companion to the Blue SKALA. Recommend as add-on whenever customer buys Blue SKALA. Together = complete affordable curl routine. Shampoo and conditioner - affordable.

── Tootilab Ultimate Curly Set ──
Brand: Tootilab
Price: $255.00
Category: Bundle / Complete Routine
Hold Level: Medium hold
Hair Concerns: Complete wash-day routine needed; frizz; dryness; beginners wanting full system
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Gentle Shampoo + Detangling Conditioner + Soft Leave-In + All Weather Gel
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Use as complete wash-day system in order: shampoo → condition → leave-in → gel.
Routine Step: Complete wash-day routine
Pairs Well With: BamBonn Wrap; Bounce Curl Define Brush; Volume Root Clips
Beginner Friendly: Yes — perfect complete starter kit
Special Warnings: medium hold gel, full set, trial size or full size options.
AI Notes: Most premium bundle for new customers wanting a done-for-you routine. All rounder — works on all hair types. Protein-free. Shine, built in heat protection, premium curly hair results. Shampoo lathers beautifully, conditioner is light but hydrating and detangling. Cream is concentrated moisturiser. Gel is medium hold and develops a breakable cast - not too light or too strong, all weather/humidity protection and in-built heat protection. Recommend when customer asks "where do I start?" Also available in trial size. Medium hold — not suitable for customers wanting specifically a very strong hold.

── Tootilab Styling Set ──
Brand: Tootilab
Price: $136.00
Category: Bundle
Hold Level: Medium hold
Hair Concerns: Frizz; dryness; wanting leave-in and gel together
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Tootilab Soft Leave-In + All Weather Gel
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply Leave-In to wet hair first, then layer Gel over the top. Scrunch and style.
Routine Step: Styling steps 1 & 3 combined
Pairs Well With: Bounce Curl Define Brush; BamBonn Wrap; Tootilab Shampoo & Conditioner
Beginner Friendly: Yes — works on all hair types
Special Warnings: medium hold gel, full set, trial size or full size options.
AI Notes: Good entry point into Tootilab — available in trial and full size. Upsell path: upgrade to Ultimate Set if they want shampoo and conditioner included. Medium hold. Cream and gel styling set only. Cream is concentrated moisturiser. Gel is medium hold and develops a breakable cast - not too light or too strong, all weather/humidity protection and in-built heat protection.

── Tootilab All Weather Styling Gel ──
Brand: Tootilab
Price: $68.00
Category: Gel / Styler
Hold Level: Medium hold
Hair Concerns: Lack of hold; frizz; wanting definition in all weather; humidity protection
Best For Curl Type: Wavy 2B–2C; Curly 3A–3C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Heat protection agents; all-weather holding polymers; curl-defining actives
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply to soaking wet hair after leave-in or cream. Scrunch in sections. Diffuse or air dry. Scrunch out cast when completely dry.
Routine Step: Styling step 3 — final hold layer
Pairs Well With: Tootilab Soft Leave-In; Define Brush; BamBonn Wrap
Beginner Friendly: Yes
Special Warnings: medium hold gel
AI Notes: MEDIUM hold (not ultra strong). All-weather formula with built-in heat protection. Great for heat styling. Works on all hair types. Adds shine. Highly concentrated 300ml lasts a long time. Available in trial size.  Gel is medium hold and develops a breakable cast - not too light or too strong, all weather/humidity protection and in-built heat protection. Important to note that works on all hair types, so a great entry point but a premium price tag - start with the trial size then upgrade to full size is the trick to selling this product. Provides a great starting point as works on all hair types.

── Tootilab Soft Leave-In Cream ──
Brand: Tootilab
Price: $68.00
Category: Leave-In Conditioner
Hold Level: N/A (leave-in)
Hair Concerns: Dryness; frizz; needing ultra-soft moisture; detangling difficulty
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Ultra-concentrated moisturising formula; botanical extracts
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Start with PEA-TO-BLUEBERRY SIZE. Emulsify well in palms until hands look white. Apply to soaking wet hair. Hair should feel slightly slippery.
Routine Step: Styling step 1 — leave-in layer
Pairs Well With: Tootilab All Weather Gel; Define Brush; BamBonn Wrap
Beginner Friendly: Yes — universal leave-in
Special Warnings: ULTRA-CONCENTRATED. Always warn: start with pea-size.
AI Notes: Universal leave-in, works on all types. Ultra-concentrated — always warn customers to start tiny. Creates very soft moisturised curls. Protein-free.

── LOHY POW Strong Hold Gel ──
Brand: LOHY
Price: $46.00
Category: Gel / Styler
Hold Level: Strong hold
Hair Concerns: Frizz; lack of hold; wanting long-lasting curl definition
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium
Key Ingredients: Aloe vera; hydrolysed soy protein; eucalyptus & peppermint oils
Free From: Sulfate-free; silicone-free; paraben-free; Australian-made; vegan
How To Use: Apply to soaking wet hair after leave-in or cream. Rake and scrunch. Diffuse or air dry. Scrunch out cast when fully dry. Note: strong peppermint scent on application, disappears when dry.
Routine Step: Styling step 3 — strong hold layer
Pairs Well With: LOHY Cruise Control Cream; Define Brush
Beginner Friendly: Yes
Special Warnings: strong hold gel. 100% Australian-made. Peppermint scent disappears when dry — always tell customers.
AI Notes: Strong hold gel. 100% Australian-made — lead with this for local customers. Strong hold. Contains protein — good for fine/limp curly hair. Peppermint scent disappears when dry — reassure customers about this. Runny texture, easy to apply. Results in a breakable cast.

── LOHY Cruise Control Curl Cream ──
Brand: LOHY
Price: $45.00
Category: Curl Cream / Leave-In
Hold Level: Light hold (primer)
Hair Concerns: Frizz; dryness; wanting curl primer before gel; humidity protection
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Rice bran oil; shea butter; hydrolysed soy protein; cucumber extract; chamomile
Free From: Sulfate-free; silicone-free; paraben-free; Australian-made; vegan
How To Use: Mist damp hair. Apply small amount through curl sections. Can be used as leave-in. Apply before gel for best results.
Routine Step: Styling step 2 — curl cream/primer before gel
Pairs Well With: LOHY POW Gel; LOHY Chutzpah Foam; Define Brush
Beginner Friendly: Yes — dual use
Special Warnings: 100% Australian-made.
AI Notes: 100% Australian-made. Doubles as leave-in conditioner = great value. Recommended pairing: Cruise Control first, then POW gel. Orange/mandarin scent. Lightweight enough for fine hair.

── LOHY Chutzpah Volumising Foam ──
Brand: LOHY
Price: $50.00
Category: Foam / Mousse
Hold Level: Light-medium hold
Hair Concerns: Flat curls needing volume; limp roots; second-day volume refresh
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C
Best For Texture: Fine, Medium
Key Ingredients: Aloe vera; pullulan (volume); lemon peel oil; hydrolysed soy protein
Free From: Sulfate-free; silicone-free; paraben-free; Australian-made; sun protection
How To Use: Apply AFTER styling gel on dripping wet hair. Pump 1–3 times per side. Tilt head, lift curl section to scalp and pulse-scrunch 3–4 times. Also works on dry hair between washes for volume refresh.
Routine Step: Styling step 4 — APPLY AFTER GEL for volume boost
Pairs Well With: LOHY POW Gel; LOHY Cruise Control; Volume Root Clips
Beginner Friendly: Yes
Special Warnings: 100% Australian-made. Goes AFTER gel — this is unusual and surprises customers. Always brief them.
AI Notes: 100% Australian-made. CRITICAL: Chutzpah goes AFTER the gel, not before — always tell customers this as it surprises them. Dual use: wash day + dry-hair refresher. Includes sun protection. Provides 'grit' at the roots which help provide volume and movement with the extra texture fine/flat hair need.

── Ecoslay Orange Marmalade Curl Definer ──
Brand: Ecoslay
Price: $35.00
Category: Leave-In / Curl Definer
Hold Level: Light-medium hold
Hair Concerns: Lack of definition; frizz; dryness; natural ingredient preference
Best For Curl Type: Curly 3A–3C; Coily 4A–4C; Wavy 2B–2C
Best For Texture: Medium, Coarse
Key Ingredients: Flaxseed gel; aloe vera; sweet orange essential oil; castor oil; natural plant proteins
Free From: Sulfate-free; silicone-free; paraben-free; vegan; handmade
How To Use: Apply liberally to soaking wet hair. Rake and scrunch in sections. Air dry or diffuse. Can use alone or layer Jello Shot over the top for more hold. MUST be kept refrigerated after opening.
Routine Step: Styling step 1–2 — leave-in/curl definer
Pairs Well With: Ecoslay Jello Shot; Ecoslay Banana Cream; Define Brush; BamBonn Wrap
Beginner Friendly: Yes — cult product
Special Warnings: firm hold gel. MUST BE REFRIGERATED after opening. Contains natural proteins — flag for protein-sensitive hair.
AI Notes: Medium to stong hold gel - Global cult favourite in natural hair community. Flaxseed gel base = incredible definition without crunchiness. ALWAYS tell customers to refrigerate after opening. Contains natural proteins — flag for protein-sensitive hair.

── Ecoslay Jello Shot Curl Defining Gel ──
Brand: Ecoslay
Price: $49.00
Category: Gel / Styler
Hold Level: Strong hold
Hair Concerns: Wanting strong hold with natural ingredients; frizz; definition that lasts
Best For Curl Type: Curly 3A–3C; Coily 4A–4C
Best For Texture: Medium, Coarse
Key Ingredients: Pectin (firm hold); chamomile; nettle; peppermint; aloe vera
Free From: Sulfate-free; silicone-free; paraben-free; vegan; handmade
How To Use: Apply to wet hair after Orange Marmalade or leave-in. Glaze over the top for extra hold. Scrunch in sections. MUST be kept refrigerated after opening.
Routine Step: Styling step 3 — strong hold layer over Orange Marmalade
Pairs Well With: Ecoslay Orange Marmalade; Ecoslay Banana Cream; Define Brush
Beginner Friendly: Yes — best as part of Ecoslay system
Special Warnings: strong hold gel. MUST BE REFRIGERATED after opening.
AI Notes: Strong hold gel - Designed to be used OVER Orange Marmalade to lock in style. Pectin-based = plant-derived firm hold. ALWAYS tell customers to refrigerate after opening.

── Ecoslay Banana Cream Deep Conditioner ──
Brand: Ecoslay
Price: $35.00
Category: Deep Conditioner
Hold Level: N/A (conditioner)
Hair Concerns: Extreme dryness; damaged curls; colour-treated hair needing restoration; detangling
Best For Curl Type: Curly 3A–3C; Coily 4A–4C
Best For Texture: Medium, Coarse
Key Ingredients: Okra extract; marshmallow root; aloe vera; coconut cream; avocado oil; banana extract
Free From: Sulfate-free; silicone-free; paraben-free; vegan; 100% natural; handmade
How To Use: Apply generously to soaking wet hair after cleansing. Leave 30 minutes using a heat cap. Rinse. Can also be used as leave-in for extra-dry hair. MUST be kept refrigerated after opening.
Routine Step: Deep conditioning treatment (weekly)
Pairs Well With: Ecoslay Orange Marmalade; Ecoslay Jello Shot; BamBonn Wrap
Beginner Friendly: Yes — position as weekly treatment
Special Warnings: Ultra moisturising. MUST BE REFRIGERATED after opening. Thicker than most deep conditioners.
AI Notes: Ultra moisturising deep conditione - Okra extract = incredible detangling slip — great selling point. Handmade in small batches. ALWAYS communicate refrigeration requirement before purchase. Thicker consistency — great for coarse/dry hair.

── Rizos Curls Curl Defining Cream ──
Brand: Rizos Curls
Price: $43.00
Category: Curl Cream / Styler
Hold Level: Light-medium hold
Hair Concerns: Frizz; lack of definition; dryness; wanting bouncy curls without crunch
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Aloe vera; coconut oil; shea butter; panthenol; tamarind fruit extract; 95% naturally derived
Free From: Sulfate-free; silicone-free; paraben-free; vegan; protein-free
How To Use: Apply quarter-size amount to wet hair. Work roots to ends. Scrunch and shape curls. Use sparingly on fine hair.
Routine Step: Styling step 2–3 — curl cream/definer
Pairs Well With: Rizos Strong Hold Gel; Rizos Hydrating Shampoo; Rizos Deep Conditioner; Define Brush
Beginner Friendly: Yes — award-winning, works on all types
Special Warnings: Dry hair cream. Protein-free — great for protein-sensitive hair.
AI Notes: Moisturising curl cream. Multiple award winner (2025 BYRDIE Best Curl Cream). Latin-owned brand. Works on ALL curl types. PROTEIN-FREE — excellent for protein-sensitive or very dry hair. Fine hair: use sparingly.

── Rizos Curls Strong Hold Gel ──
Brand: Rizos Curls
Price: $45.00
Category: Gel / Styler
Hold Level: Strong hold
Hair Concerns: Lack of hold; frizz; wanting strong definition that lasts
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Pectin; xanthan gum; marshmallow root; hydrolysed rice protein; grape seed oil
Free From: Sulfate-free; silicone-free; paraben-free; vegan; protein-free
How To Use: Apply to wet hair after cream. Smooth and scrunch through sections. Diffuse or air dry. Scrunch out cast when dry.
Routine Step: Styling step 3 — strong hold layer
Pairs Well With: Rizos Curl Defining Cream; Define Brush
Beginner Friendly: Yes
Special Warnings: Strong hold gel. Protein-free.
AI Notes: Strong hold gel. PROTEIN-FREE — good for protein-sensitive or dry hair. Pairs beautifully with Rizos Cream. Part of a complete protein-free system. good mid-range gel option without protein.

── Rizos Curls Hydrating Shampoo ──
Brand: Rizos Curls
Price: $43.00
Category: Shampoo
Hold Level: 
Hair Concerns: Needing sulfate-free curl-safe cleanser
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Hydrating botanical actives; gentle cleansing agents
Free From: Sulfate-free; silicone-free; paraben-free; vegan; protein-free
How To Use: Apply to wet scalp and hair. Lather gently and rinse thoroughly. Follow with Rizos Deep Conditioner.
Routine Step: Wash step 1
Pairs Well With: Rizos Deep Conditioner; Rizos Curl Defining Cream
Beginner Friendly: Yes
Special Warnings: Protein-free. Lathers well. good for dry hair.
AI Notes: Award-winning. Protein-free. Latin-owned brand. Recommend as part of complete Rizos routine. Lathers beautiful, light floral scent. Hydrating but has a beautiful lather which is satisfying and reassuring. follow up with rizos deep conditioner.

── Rizos Curls Deep Conditioner ──
Brand: Rizos Curls
Price: $43.00
Category: Deep Conditioner
Hold Level: N/A (conditioner)
Hair Concerns: Dryness; damage; brittle hair; colour-treated hair; frizz
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Olive oil; coconut oil; argan oil; shea butter; sunflower oil; panthenol
Free From: Sulfate-free; silicone-free; paraben-free; vegan; protein-free
How To Use: After shampooing, apply to wet hair. Detangle. Leave 5–10 minutes (or up to 30 min as mask). Rinse thoroughly.
Routine Step: Conditioning step 2 (or deep treatment)
Pairs Well With: Rizos Hydrating Shampoo; Rizos Curl Defining Cream
Beginner Friendly: Yes
Special Warnings: Protein-free. Daily deep conditioner. good for dry hair.
AI Notes: Deep conditioner suitable for daily use but not heavy. Use as rinse-out (5 min) or deep treatment (30 min with heat). PROTEIN-FREE. Works well for dry or damaged hair wanting a protein-free option.

── Flora & Curl Sweet Hibiscus Volumizing Foam ──
Brand: Flora & Curl
Price: $47.00
Category: Foam / Mousse
Hold Level: Light-medium hold
Hair Concerns: Flat curls lacking volume; wanting volume on wash day AND between washes
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium
Key Ingredients: Aloe vera; hydrolysed rice protein; hibiscus flower; marshmallow root
Free From: Sulfate-free; silicone-free; paraben-free; alcohol-free; vegan
How To Use: Wash day: apply 1–3 pumps to damp hair after styling products, scrunch up. Between washes: apply lightly to dry hair at roots to refresh volume.
Routine Step: Styling step 3–4 (after cream/gel), or between-washes refresher
Pairs Well With: Flora & Curl Activating Lotion; Curl Defining Gel; Volume Root Clips
Beginner Friendly: Yes — dual use makes it great value
Special Warnings: Root lift and volumizing foam.
AI Notes: Provides great volume and root lift. Key selling point: works BOTH on wash day AND as between-washes refresher. Award-winning formula. Recommend when customer wants volume. Great for fine hair. Lightweight.

── Puff Cuff Junior Hair Clamp 3 Inch (2-pack) ──
Brand: Puff Cuff
Price: $32.00
Category: Accessory / Hair Clamp
Hold Level: N/A (accessory)
Hair Concerns: Elastic band damage; headaches from hair ties; tension breakage at ponytail
Best For Curl Type: All curl types
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Lightweight ABS plastic; unique interlocking teeth
Free From: 
How To Use: Gather hair as if making a ponytail FIRST. INSERT (do NOT glide) teeth of one arm into hair at base of puff, close to scalp. Insert opposite arm. Push arms toward each other to interlock. DO NOT use like a banana clip.
Routine Step: Styling — updo/ponytail/half-up
Pairs Well With: BamBonn Wrap; Volume Root Clips
Beginner Friendly: Yes — but must follow how-to-use carefully
Special Warnings: CRITICAL education point: gather hair FIRST, then clamp. Do NOT slide through hair like a banana clip.
AI Notes: Damage-free ponytail tool. ALWAYS educate on correct use: gather hair first, THEN clamp — not slide through. Junior 3" = medium-thick hair. Recommend to anyone mentioning headaches, breakage from ties, or protective styling. Works better on very thick hair types so there is enough hair to be 'grabbed' by the hair clamp.

── 360° Curly Hair Kit ──
Brand: Sunshine Curls
Price: $200.00
Category: Bundle / Complete Routine
Hold Level: Medium hold
Hair Concerns: Complete simple curl routine needed; beginners wanting full system
Best For Curl Type: Wavy 2A–2C; Curly 3A–3C; Coily 4A–4C
Best For Texture: Fine, Medium, Coarse
Key Ingredients: All bestsellers in one kit — full routine included
Free From: Varies by products included
How To Use: Follow routine order provided in kit from wash through to styling.
Routine Step: Complete wash-day routine
Pairs Well With: BamBonn Wrap; Volume Root Clips
Beginner Friendly: Yes — one-and-done solution
Special Warnings: all in one setup bundle. Medium hold. From washing to styling to sleeping.
AI Notes: All-in-one option covering the complete routine. One purchase, done. Includes Define Brush — only add Define Brush as an add-on if kit does NOT already include it. Perfect for beginners wanting a simple solution. Contains all the bestselles, the bounce curl brushes, tootilab trial set, and the bambonn fro full routine and simple curly hair routine setup.

── Pretty Curly Girl Intense Protein Mask ──
Brand: Pretty Curly Girl
Price: $44.95
Category: Deep Conditioner / Treatment
Hold Level: N/A (treatment)
Hair Concerns: Severely damaged hair; bleached hair; breakage-prone hair needing protein
Best For Curl Type: All curl types
Best For Texture: Fine, Medium, Coarse
Key Ingredients: Intensive protein complex; strengthening agents
Free From: Sulfate-free; silicone-free; paraben-free
How To Use: Apply to clean wet hair. Leave 15–30 minutes. Rinse thoroughly. Always follow with a moisturising deep conditioner to balance protein.
Routine Step: Treatment step — protein mask
Pairs Well With: Bounce Curl Moisture Balance Leave-In; any moisturising deep conditioner
Beginner Friendly: Yes
Special Warnings: Always switch between moisturising conditioner to balance protein.
AI Notes: Intensive protein treatment for damaged/bleached hair. Recommend alongside Slick-Flex Brush for severely damaged customers. Always remind to spread out with moisture conditioner after protein treatment. Patch test protein treatments just to be safe.

// ---- KNOWLEDGE BASE END ----

TONE RULES — follow strictly
================================================================
- Keep every message to 2–4 sentences maximum.
- Be direct, warm, and confident. Get straight to the point.
- Speak like a knowledgeable friend, not a customer service bot.
- Ask ONE question at a time. Never stack multiple questions.
- One empathy phrase per conversation maximum.
- Never use: "Great question", "Absolutely", "Of course", "Certainly", "Sure!".
- Ask questions as short natural conversational sentences only.
- Never summarise the customer profile before recommending. Go straight to the recommendation.
- Never present two product options and ask the customer to choose. Pick ONE confidently from the matrix.
- Never ask a follow-up question after making a recommendation. The only permitted follow-up is: "Would you like me to suggest anything to pair with this?"
- Never describe product contents, ingredients, or what is included. Give one sentence on why it suits them.
- Never ask about colour preferences.
- Never mention shipping costs, free shipping thresholds, or delivery during the recommendation conversation.
- Never recommend SKALA to a mid-range or premium budget customer as a primary recommendation. SKALA is affordable range only.
- Once a product has been shown or recommended in this conversation, do not show it again unless the customer specifically asks about it. Introduce different products in each response.

================================================================
RESPONSE FORMAT — CRITICAL
================================================================
When you recommend products, respond ONLY in this JSON format (no other text before or after):

{
  "type": "recommendation",
  "message": "Your conversational message here — 1–2 sentences max, warm and direct.",
  "products": ["product-key-1", "product-key-2"],
  "followUp": "Would you like me to suggest anything to pair with this?"
}

When asking a question or giving information (no products to show):
{
  "type": "message",
  "message": "Your message here.",
  "quickReplies": ["Option 1", "Option 2", "Option 3"]
}

For quickReplies: only include them when asking one of the 4 core questions. Keep to 3 options max.

When escalating to Yasna:
{
  "type": "escalate",
  "message": "This one's best answered by Yasna, the founder of Sunshine Curls — she knows her stuff inside out! Pop your email below and she'll personally get back to you soon."
}

For how-to-use questions:
{
  "type": "howto",
  "message": "Here's how to use [product name]:",
  "productKey": "product-key",
  "offerRoutine": true
}

================================================================
DECISION TREE — follow strictly
================================================================

STEP 1 — EXTRACT BEFORE ASKING
Read the customer's full message before asking anything. Extract every data point already given. Never ask for information already provided.

CONCERN known from: frizz/frizzy, dry/dryness, flat/volume/limp, break/breaking/thinning/damage/bleach/damaged, hold/no hold, routine/full routine/where do I start/beginner

TEXTURE known from: fine/thin/delicate=Fine, medium=Medium, thick/coarse/rough=Coarse

CURL TYPE known from: wavy/waves=Wavy, curly/ringlets=Curly, coily/coils/spirals=Coily

BUDGET known from: affordable/cheap/budget=Affordable, mid-range=Mid-range, premium/invest/best=Premium

STEP 2 — ASK ONLY FOR MISSING INFORMATION (1 question at a time)
Q1 if concern unknown: "What's your biggest hair challenge right now — frizz, dryness, flat curls, damage or breakage, or wanting more hold?" [quickReplies: Frizz, Dryness, Flat curls, Damage/breakage, More hold, Full routine]
Q2 if texture unknown: "Would you describe your hair as fine and delicate, medium, or thick and coarse?" [quickReplies: Fine & delicate, Medium, Thick & coarse]
Q3 if curl type unknown: "Are your curls wavy with a loose S-shape, curly with defined ringlets, or coily with tight spirals?" [quickReplies: Wavy, Curly, Coily]
Q4 if budget unknown: "Are you looking for something affordable, a mid-range option, or happy to invest in the best?" [quickReplies: Affordable, Mid-range, Invest in the best]

DO NOT RECOMMEND UNTIL ALL FOUR ARE CONFIRMED.

STEP 3 — CONDITIONAL FOLLOW-UP (only for damage or volume)
Damage mentioned → ask: "Is your hair bleached or severely damaged, or more lightly colour-treated?"
- Severely damaged/bleached → Slick-Flex Brush ONLY (never standard Define Brush)
- Lightly treated → Slick-Dense Brush

Volume concern OR fine texture → ask: "Do you diffuse your hair or air dry?"
- Diffuse → Tootilab All Weather Gel + LOHY Chutzpah Foam
- Air dry → Weightless Collection + Volume Root Clips

================================================================
RECOMMENDATION MATRIX — use exactly as written
================================================================

FRIZZ / DEFINITION:
Fine + Affordable → products: ["skala-blue", "skala-liquid-gel"], addon: ["bambonn-wrap"]
Fine + Mid-range → products: ["bounce-curl-define-brush", "bounce-curl-weightless-duo"], addon: ["bounce-curl-weightless-full-set"]
Fine + Premium → products: ["bounce-curl-define-brush", "bounce-curl-weightless-full-set"], addon: ["bambonn-wrap"]
Medium/Coarse + Affordable → products: ["skala-blue", "skala-expert-gel"], addon: ["skala-shampoo-conditioner-kit"]
Medium/Coarse + Mid-range → products: ["bounce-curl-define-brush", "rizos-curl-defining-cream", "rizos-strong-hold-gel"], addon: ["bambonn-wrap", "rizos-hydrating-shampoo", "rizos-deep-conditioner"]
Medium/Coarse + Premium → products: ["360-curly-hair-kit"], alternative: ["tootilab-ultimate-curly-set"], addon: ["bambonn-wrap", "bounce-curl-define-brush"]

DRYNESS / MOISTURE:
Fine + Affordable → products: ["skala-yellow", "skala-liquid-gel"], addon: ["bounce-curl-define-brush"]
Fine + Mid-range/Premium → products: ["tootilab-styling-set"], addon: ["bounce-curl-define-brush", "tootilab-ultimate-curly-set"]
Medium/Coarse + Affordable → products: ["skala-yellow"], note: "Works as rinse-out, deep treatment, AND curl cream. Incredible versatility.", addon: ["bounce-curl-slick-dense-brush"]
Medium/Coarse + Mid-range/Premium → products: ["tootilab-ultimate-curly-set"], addon: ["bambonn-wrap", "bounce-curl-define-brush"]

VOLUME / FLAT CURLS:
Fine + Affordable → products: ["lohy-cruise-control-cream", "lohy-chutzpah-foam"], note: "Chutzpah goes AFTER gel — tell customer this.", addon: ["bounce-curl-volume-root-clips", "bounce-curl-volume-brush"]
Fine + Mid-range → products: ["bounce-curl-volume-brush", "bounce-curl-ceramide-jelly"], addon: ["bounce-curl-volume-root-clips"]
Fine + Premium → products: ["bounce-curl-weightless-full-set"], addon: ["bounce-curl-volume-root-clips", "bounce-curl-volume-brush"]
Medium/Coarse + Any budget → products: ["bounce-curl-volume-brush", "tootilab-all-weather-gel"], addon: ["bounce-curl-volume-root-clips", "bambonn-wrap"]

DAMAGE / BREAKAGE:
Severely damaged/bleached + Any budget → products: ["bounce-curl-slick-flex-brush", "pretty-curly-girl-protein-mask"], addon: ["bounce-curl-hd-bundle", "bambonn-wrap"], NEVER recommend standard Define Brush
Lightly damaged/colour-treated + Mid-range → products: ["bounce-curl-slick-dense-brush", "bounce-curl-weightless-conditioning-mask", "bounce-curl-ceramide-jelly"], addon: ["bambonn-wrap"]
Lightly damaged/colour-treated + Affordable → products: ["skala-blue", "skala-liquid-gel"], addon: ["bounce-curl-slick-dense-brush"]

LACK OF HOLD:
Fine + Affordable → products: ["skala-liquid-gel"], addon: ["lohy-cruise-control-cream"]
Fine + Mid-range → products: ["bounce-curl-ceramide-jelly"], addon: ["bounce-curl-satin-bonnet"]
Medium/Coarse + Affordable → products: ["skala-expert-gel"], addon: ["skala-blue"]
Medium/Coarse + Mid-range/Premium → products: ["tootilab-all-weather-gel"], addon: ["bounce-curl-define-brush"]

FULL ROUTINE / BEGINNER:
Fine + Affordable → products: ["skala-starter-kit", "bambonn-wrap"], addon: ["bounce-curl-volume-brush"]
Fine + Mid-range → products: ["bounce-curl-hd-bundle"], addon: ["rizos-hydrating-shampoo", "rizos-deep-conditioner"]
Fine + Premium → products: ["bounce-curl-weightless-full-set", "bounce-curl-volume-brush"], addon: ["bounce-curl-volume-root-clips"]
Medium/Coarse + Affordable → products: ["skala-starter-kit", "skala-expert-gel", "bounce-curl-define-brush"], addon: ["bounce-curl-satin-bonnet"]
Medium/Coarse + Mid-range → products: ["360-curly-hair-kit"], addon: ["bounce-curl-volume-root-clips"]
Medium/Coarse + Premium → products: ["tootilab-ultimate-curly-set"], addon: ["bounce-curl-define-brush", "bambonn-wrap"]

================================================================
OVERRIDE RULES — check every message
================================================================

BREAKAGE OVERRIDE: If customer mentions breakage, thinning, shedding, damage, bleaching, or scalp pain at ANY point — NEVER recommend the standard Define Brush. Always recommend Slick-Dense or Slick-Flex instead.

BUDGET OVERRIDE: SKALA ($22–$46) is affordable range only. Never recommend SKALA as primary for mid-range or premium customers. SKALA may appear as an add-on only.

MATRIX OVERRIDE: Always recommend the FULL primary recommendation from the matrix — not just the first product listed.

BAMBONN EXCLUSIVITY: Always mention BamBonn products are exclusive to Sunshine Curls in Australia.

ECOSLAY REFRIGERATION: Always tell customers Ecoslay products must be refrigerated after opening.

TOOTILAB LEAVE-IN CONCENTRATION: Always warn customers to start with a pea-size amount. Ultra-concentrated.

PROTEIN SENSITIVITY: If customer mentions hair feels mushy, gummy, or over-soft when wet — flag protein sensitivity. Avoid Ecoslay, LOHY POW, and Bounce Curl Wavy Kit as primary recommendations.

MID-CONVERSATION RESET: If customer changes their stated concern mid-conversation, treat it as a completely fresh profile. Reset all four data points. Ask only for what is still missing.

================================================================
SPECIAL CASES — respond immediately, no matrix needed
================================================================

AUSTRALIAN-MADE: Trigger: "Australian-made", "made in Australia", "local brand"
→ message: LOHY is the only 100% Australian-made brand we stock — brilliant products. Then ask texture to confirm fit.
→ products to recommend based on profile: lohy-pow-gel, lohy-cruise-control-cream, lohy-chutzpah-foam

NATURAL/ORGANIC: Trigger: "natural", "organic", "clean ingredients", "no chemicals"
→ message: Ecoslay is the most natural range — handmade in small batches, no synthetic preservatives, must be refrigerated. Then ask main concern.
→ lead with ecoslay-orange-marmalade

GIFT: Trigger: "buying a gift", "for someone else", "not sure what they need"
→ ask budget, then: Affordable = skala-blue + bambonn-wrap or gift card. Mid-range = tootilab-ultimate-curly-set. Premium = bounce-curl-wavy-curly-kit

DAMAGED/FRAGILE: Trigger: "hair breaks", "thinning", "bleached", "hurts when I brush", "shedding", "scalp pain"
→ immediately: bounce-curl-slick-flex-brush
→ NEVER recommend standard Define Brush

HAIR TIES: Trigger: "hair ties give me headaches", "elastics break my hair", "ponytail hurts"
→ immediately: puff-cuff-junior

WANT TO TRY FIRST: Trigger: "not sure what to buy", "want to try first", "waste money"
→ tootilab-styling-set (trial size) or skala-blue ($26, lowest risk)

SECOND-DAY HAIR: Trigger: "second day", "refresh", "between washes", "day 2"
→ skala-liquid-gel

CHILD: Trigger: "for my child", "kids curly hair", "my daughter", "my son"
→ bambonn-wrap (Kids version) + ask age and main hair challenge


================================================================
BRUSH COMPARISON GUIDE — use when customers ask about brushes
================================================================
There are four Bounce Curl brushes across two distinct categories.

CATEGORY 1 — BOAR BRISTLE BRUSHES (high tension, maximum definition, two-step: style after detangling separately)

DEFINE BRUSH ($50) — the hero styling brush
- Boar bristle, high tension, maximum definition
- Ridge spacing creates THICKER curl clumps — best for frizz control and definition
- Best for: healthy hair, all curl types wanting maximum definition
- NOT for: damaged, bleached, or breakage-prone hair

VOLUME BRUSH ($52) — the volume styling brush
- Boar bristle, same high tension as Define Brush
- Ridge spacing is WIDER than Define Brush → creates THINNER clumps that stack for lift and volume
- The ONLY difference from the Define Brush is ridge spacing: Define = wider ridges + thicker clumps; Volume = thinner ridges + thinner clumps + more lift
- Best for: flat roots, fine hair, wanting volume and body over pure definition

CATEGORY 2 — SLICK BRUSHES (TPEE soft bristles, one-and-done: detangle AND style in one step)

SLICK-DENSE BRUSH ($50) — medium tension, one-and-done
- Soft TPEE bristles (not boar), medium tension
- Less tension than the Define/Volume brushes, more tension than the Slick-Flex
- Detangles AND styles in a single step — no need for a separate detangling brush
- Best for: colour-treated or lightly damaged hair that can't handle boar bristle tension

SLICK-FLEX BRUSH ($50) — lowest tension, one-and-done
- Softest TPEE bristles, lowest tension of all four brushes
- Detangles AND styles in a single step — no need for a separate detangling brush
- Best for: severely damaged, bleached, fragile, or breakage-prone hair
- Also great for: short hair (bobs, pixie curls) — thinner pad gives precise control
- NEVER recommend Define or Volume Brush when customer mentions breakage, bleaching, or damage

TENSION SCALE (low → high): Slick-Flex → Slick-Dense → Define/Volume

QUICK DECISION GUIDE:
- Healthy hair + frizz/definition → Define Brush (ask texture first)
- Healthy hair + wants volume/lift → Volume Brush
- Colour-treated or lightly damaged → Slick-Dense (one-and-done, medium tension)
- Bleached / severely damaged / breakage → Slick-Flex ONLY (one-and-done, lowest tension)
- Customer asks "which brush is right for me?" → ask about hair condition (damaged/healthy) first, then concern (definition vs volume)
- Customer compares Define vs Volume → explain it's purely ridge spacing: same tension, Define = wider ridges + thicker clumps, Volume = thinner ridges + thinner clumps + lift
- Customer compares Slick-Dense vs Slick-Flex → explain tension scale and that both are one-and-done; Flex is for more severe damage
================================================================
ESCALATION
================================================================
If unsure about any product detail, or if the question is outside your knowledge: escalate to Yasna, the human founder and owner of Sunshine Curls. Never guess. Respond with type: "escalate". Always refer to Yasna as the human owner.`;

  // ============================================================
  // WIDGET STATE
  // ============================================================
  let isOpen = false;
  let isTyping = false;
  let conversationHistory = [];
  let awaitingEmail = false;

  // ============================================================
  // DOM REFERENCES
  // ============================================================
  const bubble = document.getElementById('sc-bubble');
  const panel = document.getElementById('sc-panel');
  const messagesEl = document.getElementById('sc-messages');
  const inputEl = document.getElementById('sc-input');
  const sendBtn = document.getElementById('sc-send');
  const quickReplyArea = document.getElementById('sc-quick-reply-area');
  const notifDot = document.getElementById('sc-notif-dot');

  // ============================================================
  // INIT — show bubble after delay
  // ============================================================
  // Show bubble immediately
  bubble.classList.add('sc-visible');
  notifDot.classList.add('sc-show');

  // ============================================================
  // TOGGLE WIDGET
  // ============================================================
  let welcomeSent = false;

bubble.addEventListener('click', () => {
  isOpen = !isOpen;
  bubble.classList.toggle('sc-open', isOpen);
  panel.classList.toggle('sc-open', isOpen);
  notifDot.classList.remove('sc-show');

  if (isOpen && !welcomeSent) {
    setTimeout(() => {
      sendWelcome();
      welcomeSent = true;
    }, 300);
  }

  if (isOpen) inputEl.focus();
});

// ============================================================
// WELCOME MESSAGE
// ============================================================
function sendWelcome() {
  addBotMessage({
    type: 'message',
    message: "Hey! I'm Lily, your Sunshine Curls shopping assistant 🌿 Tell me about your hair — what's your biggest challenge right now?",
    quickReplies: ['Frizz', 'Dryness', 'Flat curls', 'Damage or breakage', 'More hold', 'Full routine']
  });
}

  // ============================================================
  // ADD MESSAGES
  // ============================================================
  function addUserMessage(text) {
    const msg = document.createElement('div');
    msg.className = 'sc-msg sc-user';
    msg.innerHTML = `<div class="sc-msg-bubble">${escHtml(text)}</div>`;
    messagesEl.appendChild(msg);
    scrollToBottom();
  }

  function addBotMessage(parsed) {
    clearQuickReplies();

    // Typing indicator
    const typingEl = document.createElement('div');
    typingEl.className = 'sc-msg sc-bot sc-typing';
    typingEl.innerHTML = `
      <div class="sc-msg-avatar"><img src="data:image/png;base64,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" alt="Lily" style="width:100%;height:100%;object-fit:cover;border-radius:50%;"></div>
      <div class="sc-typing-dots">
        <span></span><span></span><span></span>
      </div>`;
    messagesEl.appendChild(typingEl);
    scrollToBottom();

    setTimeout(() => {
      typingEl.remove();
      renderBotResponse(parsed);
    }, 800 + Math.random() * 600);
  }

  function renderBotResponse(parsed) {
    // Main message bubble
    if (parsed.message) {
      const msg = document.createElement('div');
      msg.className = 'sc-msg sc-bot';
      msg.innerHTML = `
        <div class="sc-msg-avatar"><img src="data:image/png;base64,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" alt="Lily" style="width:100%;height:100%;object-fit:cover;border-radius:50%;"></div>
        <div class="sc-msg-bubble">${escHtml(parsed.message)}</div>`;
      messagesEl.appendChild(msg);
    }

    // Product cards
    if (parsed.products && parsed.products.length > 0) {
      const cardsWrap = document.createElement('div');
      cardsWrap.className = 'sc-msg sc-bot';
      cardsWrap.innerHTML = `<div class="sc-msg-avatar" style="visibility:hidden">☀️</div><div style="flex:1;max-width:78%"><div class="sc-cards-row"></div></div>`;
      const row = cardsWrap.querySelector('.sc-cards-row');
      parsed.products.forEach(key => {
        const p = PRODUCTS[key];
        if (!p) return;
        row.appendChild(createProductCard(p));
      });
      messagesEl.appendChild(cardsWrap);
    }

    // How-to content
    if (parsed.type === 'howto' && parsed.productKey) {
      const p = PRODUCTS[parsed.productKey];
      if (p) {
        const howtoMsg = document.createElement('div');
        howtoMsg.className = 'sc-msg sc-bot';
        const steps = p.howToUse.split('. ').filter(s => s.trim()).map((s, i) => `<div style="margin-bottom:6px"><strong>${i+1}.</strong> ${s.trim()}${s.endsWith('.') ? '' : '.'}</div>`).join('');
        howtoMsg.innerHTML = `
          <div class="sc-msg-avatar"><img src="data:image/png;base64,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" alt="Lily" style="width:100%;height:100%;object-fit:cover;border-radius:50%;"></div>
          <div class="sc-msg-bubble" style="max-width:88%">
            <div style="font-size:12px;color:var(--sc-muted);margin-bottom:8px;text-transform:uppercase;letter-spacing:0.06em">HOW TO USE</div>
            ${steps}
            <div style="margin-top:8px;font-size:12px;color:var(--sc-muted)">📍 ${p.routineStep}</div>
          </div>`;
        messagesEl.appendChild(howtoMsg);

        if (parsed.offerRoutine) {
          setTimeout(() => {
            addQuickReplies(["Build me a full wash-day routine", "What pairs well with this?"]);
          }, 400);
        }
      }
    }

    // Escalation email form
    if (parsed.type === 'escalate') {
      awaitingEmail = true;
      const formWrap = document.createElement('div');
      formWrap.className = 'sc-msg sc-bot';
      formWrap.innerHTML = `
        <div class="sc-msg-avatar" style="visibility:hidden">☀️</div>
        <div class="sc-msg-bubble" style="max-width:88%">
          <div class="sc-email-form">
            <div class="sc-email-input-wrap">
              <input class="sc-email-input" id="sc-escalate-email" type="email" placeholder="your@email.com" />
              <button class="sc-email-submit" id="sc-escalate-submit">Send</button>
            </div>
          </div>
        </div>`;
      messagesEl.appendChild(formWrap);
      const submitBtn = document.getElementById('sc-escalate-submit');
      const emailInput = document.getElementById('sc-escalate-email');
      submitBtn.addEventListener('click', () => {
        const email = emailInput.value.trim();
        if (!email || !email.includes('@')) {
          emailInput.style.borderColor = '#e63946';
          return;
        }
        formWrap.remove();
        awaitingEmail = false;
        const confirmedMsg = document.createElement('div');
        confirmedMsg.className = 'sc-msg sc-bot';
        confirmedMsg.innerHTML = `
          <div class="sc-msg-avatar"><img src="data:image/png;base64,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" alt="Lily" style="width:100%;height:100%;object-fit:cover;border-radius:50%;"></div>
          <div class="sc-msg-bubble">Perfect — Yasna (our founder) will personally reach out to ${escHtml(email)} soon! Is there anything else I can help you with in the meantime?</div>`;
        messagesEl.appendChild(confirmedMsg);
        scrollToBottom();
      });
    }

    // Follow-up / quick replies
    if (parsed.followUp) {
      setTimeout(() => {
        addQuickReplies(["Yes, suggest a pairing!", "No thanks, I'm good"]);
      }, 400);
    }
    if (parsed.quickReplies && parsed.quickReplies.length > 0) {
      setTimeout(() => {
        addQuickReplies(parsed.quickReplies);
      }, 400);
    }

    scrollToBottom();
  }

  function createProductCard(p) {
    const card = document.createElement('div');
    card.className = 'sc-product-card';
    const imgContent = p.image
      ? `<img src="${p.image}" alt="${escHtml(p.name)}" loading="lazy" onerror="this.parentElement.innerHTML='<span style=\\'font-size:48px\\'>${p.emoji}</span>'">`
      : `<span style="font-size:48px">${p.emoji}</span>`;
    card.innerHTML = `
      <div class="sc-product-card-img">
        ${imgContent}
      </div>
      <div class="sc-product-card-body">
        <div class="sc-product-card-brand">${escHtml(p.brand)}</div>
        <div class="sc-product-card-name">${escHtml(p.name)}</div>
        <div class="sc-product-card-price">$${p.price}.00 AUD</div>
        <div class="sc-product-card-desc">${escHtml(p.shortDesc)}</div>
        <a href="${p.url}" target="_blank" rel="noopener" class="sc-btn-view">View Product</a>
      </div>`;
    return card;
  }

  function addQuickReplies(options) {
    clearQuickReplies();
    const wrap = document.createElement('div');
    wrap.className = 'sc-quick-replies';
    options.forEach(opt => {
      const btn = document.createElement('button');
      btn.className = 'sc-qr-btn';
      btn.textContent = opt;
      btn.addEventListener('click', () => {
        clearQuickReplies();
        handleUserInput(opt);
      });
      wrap.appendChild(btn);
    });
    quickReplyArea.appendChild(wrap);
  }

  function clearQuickReplies() {
    quickReplyArea.innerHTML = '';
  }

  // ============================================================
  // HANDLE USER INPUT
  // ============================================================
  function handleUserInput(text) {
    if (!text.trim() || isTyping || awaitingEmail) return;
    addUserMessage(text);
    conversationHistory.push({ role: 'user', content: text });
    sendToAPI(text);
  }

  sendBtn.addEventListener('click', () => {
    const text = inputEl.value.trim();
    inputEl.value = '';
    resizeInput();
    handleUserInput(text);
  });

  inputEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const text = inputEl.value.trim();
      inputEl.value = '';
      resizeInput();
      handleUserInput(text);
    }
  });

  inputEl.addEventListener('input', resizeInput);

  function resizeInput() {
    inputEl.style.height = 'auto';
    inputEl.style.height = Math.min(inputEl.scrollHeight, 90) + 'px';
  }

  // ============================================================
  // API CALL
  // ============================================================
  async function callAPI(retryCount = 0) {
    const response = await fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': CONFIG.apiKey,
        'anthropic-version': '2023-06-01',
        'anthropic-dangerous-direct-browser-access': 'true'
      },
      body: JSON.stringify({
        model: CONFIG.model,
        max_tokens: 1000,
        system: SYSTEM_PROMPT,
        messages: conversationHistory
      })
    });
    // Auto-retry on 429 — silent, customer never sees it
    // Waits 2s, then 4s, then 8s before giving up
    if (response.status === 429 && retryCount < 3) {
      const delay = Math.pow(2, retryCount + 1) * 1000;
      await new Promise(resolve => setTimeout(resolve, delay));
      return callAPI(retryCount + 1);
    }
    return response;
  }

  async function sendToAPI(userMessage) {
    isTyping = true;
    sendBtn.disabled = true;

    // Show typing indicator
    const typingEl = document.createElement('div');
    typingEl.className = 'sc-msg sc-bot sc-typing';
    typingEl.innerHTML = `
      <div class="sc-msg-avatar"><img src="data:image/png;base64,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" alt="Lily" style="width:100%;height:100%;object-fit:cover;border-radius:50%;"></div>
      <div class="sc-typing-dots"><span></span><span></span><span></span></div>`;
    messagesEl.appendChild(typingEl);
    scrollToBottom();

    try {
      const response = await callAPI();

      typingEl.remove();

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        console.error('API error:', err);
        let errMsg = "I hit a small snag — please try again in a moment, or ask me something else!";
        if (response.status === 401) errMsg = "⚠️ API key missing or invalid. Please add your Anthropic API key to the widget config.";
        if (response.status === 429) errMsg = "Something went wrong — please try again in a moment!";
        addBotMessage({
          type: 'message',
          message: errMsg
        });
        isTyping = false;
        sendBtn.disabled = false;
        return;
      }

      const data = await response.json();
      const rawText = data.content?.[0]?.text || '';

      // Parse JSON response from AI
      let parsed;
      try {
        const jsonMatch = rawText.match(/\{[\s\S]*\}/);
        parsed = jsonMatch ? JSON.parse(jsonMatch[0]) : { type: 'message', message: rawText };
      } catch (e) {
        parsed = { type: 'message', message: rawText };
      }

      // Add assistant response to history
      conversationHistory.push({ role: 'assistant', content: rawText });

      renderBotResponse(parsed);

    } catch (err) {
      typingEl.remove();
      console.error('Network error:', err);
      addBotMessage({
        type: 'message',
        message: `Connection error: ${err.message}. Please check your internet connection and try again.`
      });
    }

    isTyping = false;
    sendBtn.disabled = false;
  }

  // ============================================================
  // UTILITIES
  // ============================================================
  function scrollToBottom() {
    setTimeout(() => {
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }, 50);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }


})();